import React from "react";
import { useEffect, useState } from "react";
import { Services } from "../../../api/Services";
import UserStats from "../UserStats";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import placeholder from "../../../images/placeholder.png";
import { BASE_URL_MEDIA } from "../../../api/Constants";
import { BASE_URL_COMPETITION } from "../../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';

const ChallengeModal = ({ setChallengeModal, activeid }) => {
  const [clientChallenges, setClientChallenges] = useState([]);
  const [duplicateChallenges, setDuplicateChallenges] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchchallenge, setSearchChallenge] = useState("");
  const [userId, setUserId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const filterChallenge = (e) => {
    setSearchChallenge(e.target.value);
    const value = e.target.value;
    const filteredResult = clientChallenges?.filter((item) =>
      item.title.toLowerCase().includes(value.toLowerCase())
    );
    setClientChallenges(value == "" ? duplicateChallenges : filteredResult);
  };

  //Api call for get trainer clients Challenges
  const getTrainerClientChallenges = async (id) => {
    setIsLoading(true);

    try {
      const result = await Services.getTrainerClientAssignedChallenges(id);

      if (result) {
        setChallengeModal(true);
        setIsLoading(false);
        setClientChallenges(result?.data?.data);
        setDuplicateChallenges(result?.data?.data);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTrainerClientChallenges(activeid);
  }, [activeid]);

  const showUserStats = (id) => {
    //setUserId(id);
    //setShowModal(true);
    const metaToken = localStorage.getItem("token");
    const url = `${BASE_URL_COMPETITION}/user/${id}${metaToken ? "?token=" + metaToken : ""}`;
    window.open(url, "_blank");
  };
  return (
    <div>
      {userId && showModal && (
        <div className="trainer-modal-eventWrapper trainer-modal-eventWrapper-upper">
          <div className="trainer-modal trainer-modal-lg">
            <div className="close" onClick={() => setShowModal(false)}>
              <i className="fa fa-times"></i>
            </div>
            <UserStats userId={userId} />
          </div>
        </div>
      )}

      <div className="trainer-modal-eventWrapper">
        <div className="trainer-modal trainer-modal-lg">
          {isLoading && (
            <div className="loaderparent-absolute">
              <div className="loader"></div>
            </div>
          )}
          <div className="close" onClick={() => setChallengeModal(false)}>
            <i className="fa fa-times"></i>
          </div>
          <div className="search px-2">
            <input
              type="text"
              className="form-control input"
              placeholder="Search challenge by name"
              value={searchchallenge}
              onChange={filterChallenge}
            />
          </div>

          {clientChallenges?.length == 0 && !isLoading && (
            <p className="text-center no_found my-4">No Challenge Found</p>
          )}
          <div className="group__main_wrapper px-2 mt-3">
            <div className="row">
              {clientChallenges?.map((challenge) => (
                <div className="col-12 col-md-6 col-lg-4 mb-3">
                  <div className="group__wrapper">
                    <div className="image">
                      {challenge?.image ? (
                        <img
                          src={getImageUrl(challenge?.image,  BASE_URL_MEDIA)}
                        />
                      ) : (
                        <img src={placeholder} />
                      )}
                    </div>
                    <div className="px-2 pb-2">
                      <p className="group-name">{challenge?.title}</p>
                      <div className="types">
                        <div className="type">
                          <i class="fa-solid fa-user-group"></i>{" "}
                          {challenge?.visibility}
                        </div>
                        {challenge?.start_date && (
                          <div className="type">
                            <i class="fa-regular fa-calendar-days"></i>{" "}
                            {challenge?.start_date}
                          </div>
                        )}
                        {challenge?.end_date && (
                          <div className="type">
                            <i class="fa-regular fa-calendar-days"></i>{" "}
                            {challenge?.end_date}
                          </div>
                        )}
                      </div>
                      <div className="members">
                        {challenge?.members?.map((member) =>
                          member?.image ? (
                            <img
                              onClick={() => showUserStats(member.id)}
                              src={`${BASE_URL_MEDIA}/storage/assets/uploads/${member?.image}`}
                            />
                          ) : (
                            <div
                              onClick={() => showUserStats(member.id)}
                              className="placerholder-small"
                            >
                              {member?.name.slice(0, 1)}
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengeModal;
